var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#0088CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91489 6.66656L16.149 6.6665C16.4403 6.6665 16.7314 6.70929 17.0356 6.85112C17.4002 7.0211 17.5936 7.28902 17.7291 7.48716C17.7396 7.50258 17.7495 7.51846 17.7586 7.53472C17.9179 7.81827 18 8.12441 18 8.45374C18 8.76665 17.9255 9.10756 17.7586 9.40469C17.757 9.40757 17.7554 9.41035 17.7538 9.41318L12.5516 18.3493C12.4369 18.5464 12.2258 18.6673 11.9977 18.6665C11.7697 18.6657 11.5594 18.5433 11.4461 18.3454L6.33948 9.42833C6.33801 9.42592 6.33654 9.42351 6.33508 9.42105C6.21821 9.22846 6.03747 8.93065 6.00586 8.54633C5.97681 8.19289 6.05624 7.83877 6.23383 7.53173C6.41142 7.22464 6.67877 6.97915 7.00033 6.82888C7.34512 6.66776 7.69452 6.66656 7.91489 6.66656ZM11.3617 7.94311H7.91489C7.68844 7.94311 7.60151 7.95705 7.54074 7.98547C7.45669 8.02469 7.38612 8.08923 7.33893 8.17082C7.29174 8.25245 7.2704 8.34704 7.27816 8.44173C7.28262 8.496 7.30475 8.55807 7.43525 8.77331C7.43797 8.77782 7.44065 8.78238 7.44327 8.78694L11.3617 15.6292V7.94311ZM12.6383 7.94311V15.663L16.6475 8.77609C16.6927 8.69387 16.7234 8.57506 16.7234 8.45374C16.7234 8.35532 16.703 8.26986 16.6574 8.18177C16.6095 8.11293 16.5804 8.07649 16.556 8.05154C16.5351 8.0302 16.519 8.01876 16.4962 8.00817C16.4014 7.96397 16.3044 7.94311 16.149 7.94311H12.6383Z",
    fill: "#EEF9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTon);
export default __webpack_public_path__ + "static/media/icon-ton.c657c1432d1bc1c34c8e2a7965f8050a.svg";
export { ForwardRef as ReactComponent };